var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Tooltip, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { Button, ButtonMode, ButtonVariant } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { StyledDialogContent } from '../Components/Dialog/StyledDialogContent';
import { LayoutCentral } from '../Components/LayoutCentral';
import { NoMedicationsFound } from '../Components/NoMedicationsFound';
import styles from './ReprescribeMedicationDialog.module.css';
import { ReprescribeMedicationsList } from './ReprescribeMedicationList';
import { CloseIcon, CloudUploadIcon } from '../Components/Icons';
import { heading, white50 } from '../Styles/Colours';
import { validateReprescribe } from '../Async/MedicationsSummaryAsync';
import { displayError } from '../Config/ApplicationConfig';
import { getFirstErrorMessageFromApiError } from '../Shared/DomainValidationFunctions';
import { ValidationResult } from '../Contracts/ValidateReprescribeResult.Response';
export var ReprescribeMedicationsDialog = function (props) {
    var _a = __read(useState(false), 2), showInvalidDialog = _a[0], setShowInvalidDialog = _a[1];
    var _b = __read(useState(null), 2), invalidMedicationResult = _b[0], setInvalidMedicationResult = _b[1];
    var disableReprescribeMedication = function () {
        var _a;
        if (!props.isSubmitting)
            if (props.errors.medications === undefined || ((_a = props.errors.medications) === null || _a === void 0 ? void 0 : _a.length) === 0)
                return props.values.medications.filter(function (x) { return x.selected; }).length === 0;
        return true;
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedMedications, validateReprescribeResult, invalidMedications, err_1, error;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(props.errors.medications === undefined || ((_a = props.errors.medications) === null || _a === void 0 ? void 0 : _a.length) === 0)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    selectedMedications = props.values.medications
                        .filter(function (x) { return x.selected; })
                        .map(function (result) {
                        return {
                            id: result.medication.id,
                            authoringSystem: result.medication.authoringSystem,
                            authoringSystemForeignKey: result.medication.authoringSystemForeignKey,
                            name: result.medication.name
                        };
                    });
                    return [4 /*yield*/, validateReprescribe({
                            patientMedications: selectedMedications
                        })];
                case 2:
                    validateReprescribeResult = _b.sent();
                    if (validateReprescribeResult.medicationResults.length > 0) {
                        invalidMedications = validateReprescribeResult.medicationResults.filter(function (x) { return x.validationResult !== ValidationResult.Valid; });
                        if (invalidMedications.length === 0)
                            props.submitForm();
                        else {
                            setInvalidMedicationResult(invalidMedications);
                            setShowInvalidDialog(true);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    error = getFirstErrorMessageFromApiError(err_1);
                    displayError(error);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var actionButtons = [
        React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.light, width: 161, key: 'cancel', onClick: props.onCancel, disabled: props.isSubmitting, testId: 'navigation-control-cancel' }, "Cancel"),
        React.createElement(StyledDialogButton, { key: 'represcribe', width: 161, onClick: onSubmit, disabled: disableReprescribeMedication(), testId: 'navigation-control-represcribe' }, "Save as draft")
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledDialog, { open: true, size: 'lg', modal: true, testId: 'represcribe-medication', titleComponent: React.createElement("div", { className: styles.title },
                React.createElement(CloudUploadIcon, { size: '48', color: heading }),
                React.createElement("div", { className: styles.titleText },
                    React.createElement(Typography, { variant: 'h6', color: 'inherit' },
                        React.createElement("div", { className: styles.tileFont }, "Re-prescribe medication"))),
                React.createElement("div", null,
                    React.createElement(Tooltip, { title: 'Close' },
                        React.createElement("span", null,
                            React.createElement(Button, { iconOnly: true, onClick: props.onCancel, mode: ButtonMode.text, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'close-represcribe-medication-dialog' },
                                React.createElement(CloseIcon, { size: '20', color: heading, noPadding: true })))))), actions: actionButtons, contentComponent: React.createElement(StyledDialogContent, { noPadding: true }, props.values.medications.length === 0 ? (React.createElement(LayoutCentral, null,
                React.createElement(NoMedicationsFound, { title: "You don't have any medication to re-prescribe", info: "Review your patient's medication summary to identify any finalised medications.", onClickBack: props.onCancel, backLinkText: 'Back to medication summary' }))) : (React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.medicationHeader },
                    React.createElement("span", { className: styles.selectionCount }, props.values.medications.filter(function (x) { return x.selected; }).length),
                    ' ',
                    "Medication selected"),
                React.createElement("div", { className: styles.information }, "Select the medications you want to re-prescribe and update their durations. The existing medications will be stopped and new draft medications created."),
                React.createElement(ReprescribeMedicationsList, __assign({}, props))))) }),
        showInvalidDialog && (React.createElement(StyledDialog, { open: true, size: 'xs', modal: true, testId: 'represcribe-medication', title: 'Re-prescribe medication', titleBarRight: React.createElement(Button, { iconOnly: true, onClick: function () { return setShowInvalidDialog(false); }, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'represcribe-medication-close', tooltip: 'Close' },
                React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true })), actions: [
                React.createElement(StyledDialogButton, { key: 'cancel', testId: 'represcribe-medication-cancel', onClick: function () { return setShowInvalidDialog(false); } }, "OK")
            ], contentComponent: React.createElement("div", { className: styles.dialogContent },
                React.createElement("div", { className: styles.heading }, "Selected medication(s) no longer available."),
                React.createElement("div", { className: styles.information }, "You will need to stop the following medication(s) then add new alternative(s) from the medication browser:"),
                React.createElement("ul", null, invalidMedicationResult !== null &&
                    invalidMedicationResult.map(function (med, index) {
                        var _a;
                        return React.createElement("li", { key: index }, (_a = med.medication) === null || _a === void 0 ? void 0 : _a.name);
                    }))) }))));
};
